import script from "./AppGlobalNotify.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppGlobalNotify.vue?vue&type=script&setup=true&lang=ts"

import "./AppGlobalNotify.vue?vue&type=style&index=0&id=63a419d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a419d3"]])

export default __exports__